export default __webpack_public_path__ + "7a95e93ee49513589cbcc598a2b8ee6a.png";